import React, { useState, useEffect, useRef } from 'react';
import './CircularProgressBar.css';

const CircularProgressBar = props => {
	const [initialQuizState, setInitialQuizState] = useState(props.initialQuizState)
	const completedProgressRef = React.createRef();     // for paragraphs progress bar
	const elapsedTimeRef = React.createRef();       // for time progress bar
	const progressCoverCircleRef = React.createRef();   // for the white arc at bottom of circular progress bar
	const timeCoverCircleRef = React.createRef();   // for the white arc at bottom of circular time bar
	const progressBarMounted = useRef(false);
	const timeBarMounted = useRef(false);
	const [timerId, setTimerId] = useState(-1);
	const [currentPara, setCurrentPara] = useState(0);
	const [currentQuestionNumber, setCurrentQuestionNumber] = useState(0);
	const [elapsedSeconds, setElapsedSeconds] = useState(1);
	const [elapsedMinutes, setElapsedMinutes] = useState(0);
	const [stopTimer, setStopTimer] = useState(false)
	let seconds = elapsedSeconds;
	let minutes = elapsedMinutes;
	const totalTime = (
		props.difficulty === 1 ? 40     // easy difficulty gets 40 minutes
		: props.difficulty === 2 ? 30   // 30 minutes for medium
		: 20    // 20 for hardest
	);

	let quizQuestionNumber = 26;

	const setCircle = (circle, type, update) => {   // animation of the circular progress bars
		const radius = circle.current.r.baseVal.value;
		let circumference;

		if (type === 'time') {
			circumference = (radius * 2 * Math.PI - 2 * Math.PI);
			circle.current.style.strokeDasharray = `${circumference} ${circumference}`;
			circle.current.style.strokeDashoffset = (0 - circumference);
		} else {
			circumference = type === 'coverCircle' ? (radius * 2 * Math.PI - 10) : (radius * 2 * Math.PI);
			circle.current.style.strokeDasharray = `${circumference} ${circumference}`;
			circle.current.style.strokeDashoffset = circumference;
		}

		if (update) {
			if (type === 'progress') {
				// nest line will show per theme progress in the circular progress bar
				// circle.current.style.strokeDashoffset = circumference - (props.currentPara/props.totalPara) * circumference;
				circle.current.style.strokeDashoffset = circumference - (currentQuestionNumber/quizQuestionNumber) * circumference;
			} else {
				const totalElapsedTime = (elapsedSeconds + elapsedMinutes * 60) - 1;
				circle.current.style.strokeDashoffset = (totalElapsedTime/(totalTime * 60)) * circumference - circumference;
			}
		}
	}

	const handleTimer = () => {
		const tempTimerId = setInterval(() => {
			if (seconds === 60) {
				seconds = 1;
				minutes++;
			} else seconds++;

			setElapsedMinutes(minutes)
			setElapsedSeconds(seconds);

			if (minutes === totalTime) {
				props.timeOver();
				setStopTimer(true);
			}
		}, 1000);
		setTimerId(tempTimerId);
	}

	useEffect(() => {
		// circular progress animation inspired from https://css-tricks.com/building-progress-ring-quickly/
		setCircle(completedProgressRef, 'progress')
		if (!progressBarMounted.current) {
			setCircle(progressCoverCircleRef, 'coverCircle')
			progressBarMounted.current = true;
		} else {
			setCurrentPara(props.currentPara);
			const qNumber = currentQuestionNumber + 1;
			setCurrentQuestionNumber(qNumber);
			setCircle(completedProgressRef, 'progress', true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.currentPara]);

	useEffect(() => {
		if (!props.initialQuizState) {
			setInitialQuizState(false)
			handleTimer();
			setCurrentPara(props.currentPara);
			setCurrentQuestionNumber(1)
			setCircle(completedProgressRef, 'progress', true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.initialQuizState]);

	useEffect(() => {
		if (props.startQuizOver) {
			setElapsedMinutes(0);
			setElapsedSeconds(0);
			// eslint-disable-next-line react-hooks/exhaustive-deps
			minutes = 0;
			// eslint-disable-next-line react-hooks/exhaustive-deps
			seconds = 0;
			setCircle(elapsedTimeRef, 'time');
			setCircle(completedProgressRef, 'progress', true);
			handleTimer();
			props.quizStarted();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.startQuizOver]);

	useEffect(() => {
		if (props.quizFinished || stopTimer) {
			clearInterval(timerId);
			props.elapsedTime([minutes, seconds]);
			props.resetQuizFinishedState();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.quizFinished, stopTimer]);

	useEffect(() => {
		setCircle(elapsedTimeRef, 'time')
		if (!timeBarMounted.current) {
			setCircle(timeCoverCircleRef, 'coverCircle')
			timeBarMounted.current = true;
		} else {
			if (!initialQuizState) setCircle(elapsedTimeRef, 'time', true)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [elapsedSeconds]);

	let minutesText = totalTime === minutes ? '0': (totalTime - (minutes + 1));
	minutesText = minutesText < 10 ? '0' + minutesText : minutesText;
	let secondsText = totalTime === minutes || seconds === 0 ? '0' : (60 - seconds);
	secondsText = secondsText < 10 ? '0' + secondsText : secondsText;

	return [
		<div className='progress-container' key={1}>
			<svg width="70" height="70">
				<circle
					className="progress-ring-circle-bg"
					stroke="#D8D8D8" strokeWidth="2"
					fill="transparent" r="25" cx="35" cy="35"
				/>
				<circle
					ref={completedProgressRef}
					className="progress-ring-circle"
					stroke="#8AD46F" strokeWidth="2"
					fill="transparent" r="25" cx="35" cy="35"
				/>
				<circle
					ref={progressCoverCircleRef}
					className='cover-circle'
					stroke="#fff" strokeWidth="4"
					fill="transparent" r="25" cx="35" cy="35"
				/>
			</svg>
			<p className={"progress-text"}>
				{/*To show per theme progress in circular progress bar (numbers)*/}
				{/*{initialQuizState ? '0/0' : `${currentPara}/${props.totalPara}`}*/}
				{initialQuizState ? '0/0' : `${currentQuestionNumber}/${quizQuestionNumber}`}
			</p>
		</div>,
		<div className='progress-time-container' key={2}>
			<svg width="70" height="70">
				<circle
					className="progress-ring-circle-bg"
					stroke={ initialQuizState || (totalTime - minutes >= 5) ? "#8AA8F7" : '#F58C8C' }
					strokeWidth="2" fill="transparent" r="25" cx="35" cy="35"
				/>
				<circle
					ref={elapsedTimeRef}
					className="progress-ring-circle"
					stroke="#D8D8D8" strokeWidth="2"
					fill="transparent" r="25" cx="35" cy="35"
				/>
				<circle
					ref={timeCoverCircleRef}
					className='cover-circle'
					stroke="#fff" strokeWidth="4"
					fill="transparent" r="25" cx="35" cy="35"
				/>
			</svg>
			<p className={"progress-text"} style={{ 'color': initialQuizState || (totalTime - minutes >= 5) ? '#666' : "#F58C8C" }}>
				{initialQuizState ? `00:00` : `${minutesText}:${secondsText}`}
			</p>
		</div>
	]
};

export default CircularProgressBar;


